module.exports = __webpack_public_path__ + "img/slide-product.a7f825f5.jpg";